<template>
  <van-list
    v-model="listLoading"
    :finished="finished"
    :finished-text="finishedText"
    @load="nextPage"
    class="list-content order-list"
  >
    <van-cell v-for="(item, index) in list" :key="index">
      <!-- <div class="time-top" v-if="item.tips">
      <img src="@/static/images/order/time-01.png">
      <span v-html="item.tips"></span>
    </div> -->

      <div class="list-item" @click="goPage(item)">
        <!-- 续保续费页面列表 -->
        <div
          class="top-box"
          v-if="pageFlag == 'xfFlag' && item.needRenewalDesc"
        >
          <!-- <div class="text" v-if="pageFlag=='xfFlag'">{{item.needRenewalDesc}}</div> -->
          <div class="text">
            <span>{{ item.needRenewalTilte }}</span
            ><span style="color: #ff7134">{{ item.needRenewalNum }}</span
            ><span>{{ item.needRenewalDay }}</span>
          </div>
        </div>
        <!-- 其他页面列表 -->
        <div class="top-box" v-if="pageFlag != 'xfFlag'">
          <div
            class="tag"
            v-if="pageFlag != 'rhPage'"
            :class="{
              orange: item.orderStatus == 1 || item.orderStatus == -9,
              blue:
                [2, 7, 10].includes(item.orderStatus * 1) ||
                [1].includes(item.policyStatus * 1),
            }"
          >
            <span>{{
              item.orderDesc || item.policyDesc || item.policyStatusDesc
            }}</span>
            <span
              v-if="
                (item.doubleRecordStatus &&
                  item.orderStatus != 5 &&
                  item.orderStatus != 6 &&
                  item.orderStatus != 8) ||
                item.doubleRecordStatus == 0
              "
              >-{{ item.doubleRecordStatus | filterDoubleRecordStatus }}</span
            >
          </div>
        </div>
        <div class="content-box">
          <img
            src="@static/images/order/icon-lr.png"
            v-if="item.resource == 3"
            class="icon"
          />
          <img
            src="@static/images/order/icon-gl.png"
            v-if="item.resource == 2 || item.resource == 4"
            class="icon"
          />
          <div class="title">{{ item.productName }}</div>
          <div class="left-box">
            <div class="text">
              <span class="label">投/被保人：</span>{{ item.policyerName
              }}<span v-if="item.policyerName && item.insuranceName">/</span
              >{{ item.insuranceName }}
            </div>
            <div class="text" v-if="pageFlag == 'xfFlag' && policyType == 2">
              <span class="label">应交日期：</span
              >{{ item.needPayTime | timeSplit }}
            </div>
            <div class="text" v-else>
              <span class="label">保障期限：</span
              >{{ item.startTime | timeSplit }}至{{ item | filterEndTime }}
            </div>
            <div class="text" v-if="pageFlag != 'dzbdPage'">
              <span class="label">保费：</span>{{ item.fee | filterFee }}元
            </div>
            <div class="text">
              <span class="label">投保时间：</span
              >{{ item.createTime | timeStatus }}
            </div>
          </div>
          <!-- 人核单页面按钮显示 -->
          <div
            class="text-audit"
            v-if="pageFlag == 'rhPage'"
            :class="{
              orange: [4, 6, 8, -9].includes(item.orderStatus * 1),
              blue: [1, 2, 3, 5, 9, 7].includes(item.orderStatus * 1),
            }"
          >
            {{ item.manualDesc }}
          </div>
          <div
            class="float-img"
            v-if="
              [1, 5, -9].includes(item.orderStatus * 1) && pageFlag == 'rhPage'
            "
          >
            <img class="status-img" src="@static/images/order/wzf.png" />
          </div>
          <div
            class="float-img"
            v-if="
              [2, 3, 9].includes(item.orderStatus * 1) && pageFlag == 'rhPage'
            "
          >
            <img class="status-img" src="@static/images/order/yzf.png" />
          </div>
          <div class="right-box" v-if="pageFlag == 'rhPage'">
            <div
              class="btn"
              @click.stop="jumpPageToken(item.plat, item.manualUrl)"
            >
              核保详情
            </div>
            <div
              class="btn"
              v-if="showCXTBTN(item)"
              @click.stop="jumpPageToken(item.plat, item.productUrl)"
            >
              重新投保
            </div>
            <div
              class="btn btn-ljzf"
              v-if="item.orderStatus == 1 || item.orderStatus == -9"
              @click.stop="jumpPageToken(item.plat, item.payUrl)"
            >
              立即支付
            </div>
          </div>
          <!-- 投保单页面按钮显示 -->
          <div class="right-box" v-if="pageFlag == 'orderOrPolicy'">
            <!-- -1无需质检，0质检回复，1质检中，2质检成功，3质检失败 -->
            <div
              class="btn"
              v-if="item.qualityStatus === 0 && item.qualityUrl"
              @click.stop="jumpPageToken(item.plat, item.qualityUrl)"
            >
              质检回复
            </div>
            <div
              class="btn"
              v-if="item.orderStatus == 1 || item.orderStatus == -9"
              @click.stop="jumpPageToken(item.plat, item.payUrl)"
            >
              立即支付
            </div>
            <div
              class="btn cdbtn"
              v-if="item.canCancelOrder"
              @click.stop="cancelOrder(item)"
            >
              撤单
            </div>
            <div
              class="btn"
              v-else-if="item.orderStatus == 7"
              @click.stop="jumpPageToken(item.plat, item.manualUrl)"
            >
              核保详情
            </div>
            <!-- 核保失败，代投的单额外处理 -->
            <div
              class="btn"
              v-if="item.orderStatus == 4 && item.isReplaceInsure"
              @click.stop="jumpPageToken(item.plat, item.productUrl)"
            >
              重新投保
            </div>
            <div
              class="btn"
              v-else-if="showCXTB(item)"
              @click.stop="jumpPageToken(item.plat, item.productUrl)"
            >
              重新投保
            </div>
          </div>
          <!-- 回访页面按钮显示 -->
          <div class="right-box" v-if="pageFlag == 'hfPage'">
            <div
              class="btn"
              v-if="item.revisitUrl"
              @click.stop="jumpPageToken(item.plat, item.revisitUrl)"
            >
              在线回访
            </div>
            <div
              class="btn"
              v-if="item.receiptUrl"
              @click.stop="jumpPageToken(item.plat, item.receiptUrl)"
            >
              在线回执
            </div>
          </div>
          <!-- 回访页面按钮显示 -->
          <div class="right-box" v-if="pageFlag == 'dzbdPage'">
            <div
              class="btn"
              v-if="[1, 3, 4].includes(item.policyStatus)"
              @click.stop="downloadPDF(item.plat, item.policyNo)"
            >
              电子保单下载
            </div>
          </div>
        </div>
      </div>
    </van-cell>

    <div class="null" v-if="list.length <= 0 && !listLoading">
      <img class="null-img" src="@static/images/null.png" />
      <span class="null-text">暂无内容</span>
    </div>
    <van-dialog
      v-model="show"
      className="downLoadDialog"
      title="下载"
      @confirm="confirmDownLoad"
      show-cancel-button
      confirm-button-color="#333333"
      cancel-button-color="#8A9095"
    >
      <div slot="default">
        <img
          style="width: 30px; height: 30px"
          src="@static/images/order/pdf.png"
        />
        <span class="desc">{{ pdfFileName }}</span>
      </div>
    </van-dialog>
  </van-list>
</template>

<script>
import { pageTools, common } from "@/api/mixins";
export default {
  mixins: [pageTools, common],
  props: {
    url: null,
    isOrder: null,
    type: null,
    pageFlag: String,
    policyType: Number,
  },
  data() {
    return {
      list: [],
      pdfFileName: "",
      downloadData: "",
      show: false,
    };
  },
  watch: {},
  mounted() {},
  methods: {
    init(url) {
      // this.pageNum = 1;
      this.initListAjax(url);
    },
    // 设置自定义参数
    setListParams(params) {
      this.$emit("setListParams", params);
    },
    listCallback(res) {
      this.$emit("listCallback", res);
    },
    // 跳转投保确认页
    // jumpProductOeder(item){
    //   let base = this.$config.env==1?"https://www.fxyf99.com":"https://fqyf.wts9999.net";
    //   location.href = base+"/m/product/premium_assist/"+item.orderNo;
    // },
    // 显示重新投保按钮 代投不显示
    showCXTB(detail) {
      return (
        [3, 4, 5, 6, 8].includes(detail.orderStatus * 1) &&
        !detail.isReplaceInsure
      );
    },
    // 人核单显示重新投保按钮 代投不显示
    showCXTBTN(detail) {
      return (
        [4, 6, 8].includes(detail.orderStatus * 1) && !detail.isReplaceInsure
      );
    },
    // 电子保单下载
    downloadPDF(plat, policyNo) {
      this.loading = true;
      this.$http({
        type: "GET",
        url: `/api/downloadPolicy/${plat}/${policyNo}`,
        // 设置返回数据类型，这里一定要设置，否则下载下来的pdf会是空白
        // 　　　　responseType: "blob",
      })
        .then((res) => {
          this.loading = false;
          if (res.data) {
            this.show = true;
            this.pdfFileName = `${policyNo}.pdf`;
            this.downloadData = res.data;
          } else {
            this.$notice.msg("电子保单暂未生成");
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    confirmDownLoad() {
      if (this.downloadData) {
        location.href = this.downloadData;
      } else {
        this.$notice.msg("电子保单下载失败");
      }
    },
    // 跳转详情页
    goPage(item) {
      if (item.resource == 3) {
        this.$router.push({
          path: "/m/order/importOutsideOrderDetail",
          query: { id: item.id },
        });
        return;
      }
      let query = "";
      switch (this.pageFlag) {
        case "orderOrPolicy":
          // 投保单页面
          if (item.realPolicyNo) {
            query = {
              orderNo: item.orderNo,
              policyNo: item.realPolicyNo,
              flag: "policy",
              plat: item.plat,
              pageFlag: this.pageFlag,
            };
          } else {
            query = {
              orderNo: item.orderNo,
              flag: "order",
              plat: item.plat,
              pageFlag: this.pageFlag,
            };
          }
          break;
        case "rhPage":
          if (item.realPolicyNo) {
            //人核单页面,如果有保单号，请求保单详情接口
            query = {
              policyNo: item.realPolicyNo,
              flag: "policy",
              plat: item.plat,
              pageFlag: this.pageFlag,
            };
          } else {
            //人核单页面，没有保单号，请求订单详情接口
            query = {
              orderNo: item.orderNo,
              flag: "order",
              plat: item.plat,
              pageFlag: this.pageFlag,
            };
          }
          break;
        case "hfPage":
          // 回访页面
          query = {
            policyNo: item.policyNo,
            flag: "policy",
            plat: item.plat,
            pageFlag: this.pageFlag,
          };
          break;
        case "xfFlag":
          // 续费续保页面
          query = {
            policyNo: item.policyNo,
            flag: "policy",
            plat: item.plat,
            pageFlag: this.pageFlag,
          };
          break;
        case "dzbdPage":
          // 电子保单下载
          query = {
            policyNo: item.policyNo,
            flag: "policy",
            plat: item.plat,
            pageFlag: this.pageFlag,
          };
          break;
      }
      if(item.realPolicyNo){
        query.realPolicyNo = item.realPolicyNo;
      }
      this.$router.push({ path: "/m/order/detail", query: query });
    },
    // 是否撤单提示
    cancelOrder(item) {
      this.$dialog
        .confirm({
          message: "是否撤单?",
          className: "cddialog",
        })
        .then(() => {
          if (item.canCancelOrderLink) {
            this.$http({
              type: "GET",
              url: `/api/getOrderCancelUrl?orderNo=${item.orderNo}`,
              data: {},
            }).then((res) => {
              if (res.data) {
                location.href = res.data;
              } else {
                this.$notice.msg("撤单链接不存在");
              }
            });
          } else {
            this.$http({
              type: "PUT",
              url: `/api/insure/insureProcess?insureUniqueId=${item.orderNo}&step=TCO`,
              data: {},
            }).then((res) => {
              if (res.httpCode == 1) {
                if (res.data.data.resultFlag && res.data.curStep == "TCO") {
                  this.$emit("init");
                  this.$notice.msg("撤单成功");
                }
              }
            });
          }
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  filters: {
    filterEndTime(item) {
      if (item.endTime == "2888-01-01 00:00:00" || item.guarateeType == 1) {
        return "终身";
      } else if (!item.endTime) {
        return;
      } else {
        return item.endTime.substring(0, 10).replace(/-/g, "/");
      }
    },
    filterFee(val) {
      if (!val) {
        return "0.00";
      } else {
        return val.toFixed(2);
      }
    },
    filterDoubleRecordStatus(val) {
      if (val == "0") {
        return "等待录音录像";
      } else if (val == "-1") {
        return "录音录像审核不通过";
      } else if (val == "1") {
        return "录音录像审核中";
      } else if (val == "2") {
        return "录音录像审核通过";
      } else if (val == "-2") {
        return "录音录像待补录";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./list.scss";
</style>
<style lang="scss">
.cddialog,
.downLoadDialog {
  border-radius: 10px;
  .van-dialog__message {
    font-size: 28px;
    color: #666666;
  }
  .van-dialog__footer {
    background: #e7e7e7;
    .van-button {
      background: #f5f7fa;
    }
    .van-dialog__cancel,
    .van-dialog__confirm {
      font-size: 28px;
      font-weight: 400;
      line-height: 40px;
    }
    .van-dialog__cancel {
      color: #8a9095;
      border-right: 1px solid #e7e7e7;
    }
    .van-dialog__confirm {
      color: #333333;
    }
  }
}
.downLoadDialog {
  .van-dialog__header {
    font-size: 34px;
    font-weight: 500;
    line-height: 48px;
    color: #333333;
  }
  .van-dialog__content {
    word-break: break-all;
    padding: 40px;
    > div {
      display: flex;
      align-items: flex-start;
      .desc {
        font-size: 28px;
        font-weight: 400;
        line-height: 40px;
        color: #666666;
        margin-left: 20px;
      }
    }
  }
}
</style>
